<template>
  <div class="content-wrapper">
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <app-breadcrumb
          :page-title="$t('packages')"
          :directory="$t('datatables')"
          :icon="'grid'"
        />
      </div>
      <div class="content-wrapper">
        <span
          >You currently have no packages selected. Please select one of the below to
          continue using the portal.</span
        >
      </div>

      <div class="col-sm-12 col-md-6">
        <div class="form-group">
          <label>{{ $t("business_category") }}</label>
          <app-input
            type="search-select"
            :placeholder="$t('select_business_category')"
            :list="categories"
            v-model="inputs.category_id"
            :required="true"
          />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12"></div>
    </div>
    <div class="row">
      <div class="col-sm-4" v-for="(item, index) in packages" :key="index">
        <div class="card mb-3">
          <div class="p-2">
            <div
              v-if="item.background !== null"
              :style="{
                'background-image': 'url(' + item.background + ')',
                'background-size': 'contain',
                'background-repeat': 'no-repeat',
                width: '100%',
                height: '100px',
              }"
            ></div>

            <h2 class="text-center" v-else style="color: #292f4c">{{ item.title }}</h2>
          </div>
          <div class="card-body text-center">
            <h3>{{ item.amount }}</h3>
            <h5 class="text-muted">
              <small>{{ item.time_period + " " + item.period }}</small>
            </h5>
          </div>
          <!-- <ul class="list-group list-group-flush text-center" v-for="inc in item.include" :key="inc">
            <li class="list-group-item"><i class="fas fa-check mx-2" style="color:#292f4c"></i>{{ inc }}</li>
          </ul> -->
          <span class="text-center m-2" v-html="item.include"></span>
          <div class="card-footer border-top-0 text-center">
            <a
              href="#"
              @click="btnSubmit(item.id)"
              class="btn btn-primary text-uppercase px-4 py-2"
              style="background-color: #292f4c; border-color: #292f4c"
            >
              {{ $t("Purchase Now") }}
              <i class="fas fa-arrow-right ms-2"></i>
            </a>
            <p class="mt-3 mb-0 small text-muted">
              By clicking <strong>Purchase Now</strong>, you agree to our
              <a
                href="/screening/terms-and-conditions"
                target="_blank"
                class="fw-bold"
                style="color: #292f4c; text-decoration: underline"
              >
                Terms &amp; Conditions </a
              >.
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- Terms & Conditions Modal -->
    <!-- Terms & Conditions Modal -->
    <el-dialog
      :visible.sync="showTermsModal"
      width="820px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="Subscriber Onboarding Terms & Conditions"
    >
      <div style="max-height: 60vh; overflow: auto; padding-right: 8px">
        <!-- Full document content (rendered into semantic HTML) -->
        <div class="terms-content" v-html="formattedTerms"></div>
      </div>

      <div class="mt-3">
        <el-checkbox v-model="agreedToTerms">
          I have read and accept the Terms & Conditions.
        </el-checkbox>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="declineTerms">Cancel</el-button>
        <el-button type="primary" :disabled="!agreedToTerms" @click="acceptTerms">
          Accept & Continue to Payment
        </el-button>
      </span>
    </el-dialog>

    <packages-paymentmodal
      v-if="isPaymentModalActive"
      :data="inputs"
      :selected-url="selectedUrl"
      @close-modal="closePaymentModal"
    />

    <app-delete-modal
      v-if="deleteConfirmationModalActive"
      :preloader="deleteLoader"
      modal-id="demo-delete"
      @confirmed="confirmed"
      @cancelled="cancelled"
    />
  </div>
</template>

<script>
import CoreLibrary from "../../../../../core/helpers/CoreLibrary.js";
import * as actions from "../../../../Config/ApiUrl";
import { TableHelpers } from "../../Demo/Tables/mixins/TableHelpers";
import { axiosGet } from "../../../../Helpers/AxiosHelper.js";
import { FormMixin } from "../../../../../core/mixins/form/FormMixin";

export default {
  extends: CoreLibrary,
  name: "Packages",
  mixins: [TableHelpers, FormMixin],
  data() {
    return {
      inputs: {},
      // categories:[
      //   {íd: "", value:""},
      //   {íd: "Construction", value:"Construction"},
      //   {íd: "Security", value:"Security"},
      // ],
      // categories: [
      //   // { id: "", value: "Choose One" },
      //   { id: "Construction", value: "Construction" },
      //   { id: "Security", value: "Security" },
      // ],

      showTermsModal: false,
      agreedToTerms: false,
      categories: [],
      packages: {},
      isPaymentModalActive: false,
      deleteConfirmationModalActive: false,
      deleteLoader: false,
      tableId: "advance-table",
      rowData: {},
      options: {
        name: "AdvanceTable",
        url: actions.PACKAGE_LISTING,
        // url: actions.DATATABLE_DATA,
        showHeader: true,
        columns: [
          {
            title: this.$t("title"),
            type: "custom-html",
            key: "title",
            modifier: (value) => {
              return `<span>${this.$t(value)}</span>`;
            },
          },
          {
            title: this.$t("period"),
            type: "custom-html",
            key: "period",
            modifier: (value) => {
              return `<span>${this.$t(value)}</span>`;
            },
          },
        ],
        actions: [
          // {
          //   title: this.$t("edit"),
          //   icon: "edit",
          //   type: "none",
          //   component: "app-add-modal",
          //   modalId: "demo-add-edit-Modal",
          // },
          // {
          //   title: this.$t("delete"),
          //   icon: "trash",
          //   type: "none",
          //   component: "app-confirmation-modal",
          //   modalId: "demo-delete",
          // },
          {
            title: this.$t("select"),
            icon: "edit",
            type: "none",
            component: "app-add-modal",
            modalId: "demo-add-edit-Modal",
          },
        ],
        filters: [
          // {
          //     "title": this.$t('date'),
          //     "type": "range-picker",
          //     "key": "date",
          //     "option": ["today", "thisMonth", "last7Days", "nextYear"]
          // },
          // {
          //     "title": this.$t('age'),
          //     "type": "range-filter",
          //     "key": "age-range",
          //     "maxTitle": this.$t('max_age'),
          //     "minTitle": this.$t('min_age'),
          //     "sign": ""
          // },
          // {
          //     "title": this.$t('status'),
          //     "type": "checkbox",
          //     "key": "status",
          //     "option": [
          //         {id: 'active', value: 'Active'},
          //         {id: 'inactive', value: 'Inactive'},
          //         {id: 'invited', value: 'Invited'},
          //     ],
          // },
          // {
          //     "title": this.$t('gender'),
          //     "type": "radio",
          //     "key": "filter-with-gender",
          //     "option": [
          //         {id: 'male', value: 'Male'},
          //         {id: 'female', value: 'Female'},
          //         {id: 'other', value: 'Other'},
          //     ],
          //     "header": {
          //         "title": this.$t('want_to_filter_your_list'),
          //         "description": this.$t('you_can_filter_your_data_table_which_are_created_based_on_gender'),
          //     },
          // },
          // {
          //     "title": this.$t('search_and_select'),
          //     "type": "drop-down-filter",
          //     "key": "search select",
          //     "option": [],
          // }
        ],
        showFilter: true,
        showSearch: true,
        showCount: true,
        showClearFilter: true,
        paginationType: "pagination",
        responsive: true,
        rowLimit: 10,
        showAction: true,
        orderBy: "desc",
        actionType: "default",
      },
      pendingSelection: {
        packageId: null,
        categoryObj: null,
      },
      termsContent: `SOFTWARE LICENCE AND SERVICE AGREEMENT
Staff Vetting & Screening Software aligned to BS7858:2019 and UK legislation.

Software Licence and Service Agreement

1. Interpretation and Definitions
This Agreement uses the following definitions:
    • Affiliate: Any entity, individual, firm, or corporation controlling, controlled by, or under common control with a party.
    • Agreement: This contract between the Customer and the Company comprising a Purchase Order Form (if any) and these Terms & Conditions, or these Terms alone where no Purchase Order Form exists.
    • Applicable Laws: All laws, regulations, and guidance binding in the UK, including Data Protection Legislation, Modern Slavery Laws, Bribery Laws, Employment law, BS7858:2019, and other industry codes.
    • Business Day: Any day other than a Saturday, Sunday, or UK bank holiday.
    • Charges: All fees for the Licensed Software or Services payable under this Agreement.
    • Customer / Subscriber / User: The contracting organisation and its authorised Users.
    • Customer Data: All data input by the Customer or its Users, excluding Company proprietary data.
    • Data Protection Legislation: UK GDPR, Data Protection Act 2018, PECR 2003, and successors.
    • Documentation: Manuals, user guides, FAQs, or other support materials.
    • Implementation Services: Installation, setup, training, or configuration assistance.
    • Initial Term: Twelve (12) months from Effective Date unless otherwise agreed.
    • Intellectual Property Rights (IPR): All intellectual property rights worldwide.
    • Licensed Software: The software product, server/client modules, SaaS and Documentation licensed hereunder.
    • Modern Slavery Laws: The Modern Slavery Act 2015.
    • Services: Software access and related services provided under this Agreement.
    • Software Licence: The limited right to access and use the Software.
    • Subscription Fees: Fees for access and Services.
    • Support Services: Product support described in Clause 4.
    • Term: The Initial Term and any renewal or Rollover Periods.
2. Subscription and Licence Terms
    • Access is granted only for internal business use, subject to concurrent User limits.
    • Subscriptions auto-renew monthly unless terminated on 30 days’ written notice.
    • Users must maintain secure credentials and use the Software responsibly.
    • Misuse (e.g., fraudulent data entry, unlawful use, circumventing security) is prohibited and may lead to immediate termination.
3. BS7858:2019 Screening Requirements
    • Subscribers must comply with BS7858:2019 for staff screening including:
        ◦ Identity and right to work verification.
        ◦ Employment history (5–10 years), reference checks, gap analysis.
        ◦ Criminal record (DBS) checks where lawful.
        ◦ Financial checks where role-relevant.
        ◦ Secure record-keeping, retention, and audit trails.
    • Benefits: Supports HR compliance, reduces recruitment risks, strengthens audit readiness, and demonstrates due diligence.
    • Software Support: Provides structured workflows, evidence storage, reporting tools, and audit exports. The Company does not validate or certify compliance.
4. Company Obligations
    • Provide Software and Services with reasonable skill and care.
    • Maintain necessary licences and consents.
    • Provide Updates and Support as described.
    • No warranty for uninterrupted or error-free operation.
    • The Company may engage sub-processors subject to Data Protection obligations.
5. Customer Obligations
The Customer shall:
    • Ensure accuracy and legality of all data entered.
    • Maintain necessary IT infrastructure, security, and antivirus protections.
    • Train Users and ensure competence.
    • Obtain lawful consents and notices for data processing.
    • Use the Software as an aid, not a replacement for HR/management expertise.
6. Data Protection
    • The Customer is the Controller; the Company is a Processor only where engaged.
    • The Company processes data only on documented instructions.
    • The Company implements appropriate technical and organisational measures (Article 32 UK GDPR).
    • Transfers outside the UK require prior consent and safeguards.
    • Data breaches must be notified without undue delay.
    • The Company assists with subject rights requests at the Customer’s cost.
7. Intellectual Property
    • All IPR in the Software remains with the Company.
    • Customer Data remains the Customer’s property.
    • No transfer of IPR occurs except as licensed herein.
8. Confidentiality
    • Both parties must keep Confidential Information secure.
    • Exceptions apply where information is public, lawfully received, independently developed, or legally required.
    • Customer Data is deemed the Customer’s Confidential Information.
9. Charges and Payment
    • Fees are payable as per the Purchase Order Form or invoice.
    • Payment is due within 21 days of invoice (unless otherwise agreed).
    • In case of delayed payment, it shall be mandatory to enforce charity through the company administration.
    • Non-payment may result in suspension or termination.
10. Indemnities
    • Customer indemnifies the Company against claims arising from misuse, non-compliance, or third-party reliance on outputs.
    • The Company indemnifies the Customer against third-party IPR claims for authorised Software use.
11. Limitation of Liability
    • Excludes liability for indirect, consequential, or special losses.
    • Caps liability to fees paid in the 12 months preceding a claim.
    • No exclusion for death/personal injury by negligence or fraud.
12. Termination
    • Either party may terminate for unremedied material breach (30 days’ notice).
    • Termination triggers include insolvency, unlawful use, or security risk.
    • On termination, all licences cease; Customer Data will be returned or securely destroyed upon request.
13. Third-Party Providers
    • The Software may integrate with third-party products/services. Contracts with third parties are solely between the Customer and the third party.
14. Force Majeure
    • Neither party is liable for failure/delay caused by events beyond reasonable control (e.g., strikes, disasters, epidemics, government orders).
15. Notices
    • Notices must be delivered by hand, post, or email to registered/principal addresses.
    • Deemed receipt: hand (on delivery), post (2 Business Days after posting), email (next Business Day).
16. General Provisions
    • No partnership, joint venture, or agency relationship is created.
    • Rights and remedies are cumulative.
    • Variation requires written agreement.
    • Waivers must be in writing.
    • Severance applies where provisions are invalid/unlawful.
    • No third-party rights under the Contracts (Rights of Third Parties) Act 1999.
17. Governing Law & Jurisdiction
    • This Agreement is governed by the laws of England and Wales.
    • Disputes fall within the exclusive jurisdiction of the courts of England and Wales.
18. Entire Agreement
    • This Agreement constitutes the entire agreement and supersedes prior arrangements.
    • Parties confirm they have not relied on statements outside this Agreement.
19. Acknowledgement
By subscribing, the Customer confirms they have read, understood, and accepted these Terms, acknowledge the Company’s limited role, and assume full responsibility for compliance, HR decisions, and lawful data use.
Annex – BS7858:2019 Checklist
    • Verify identity & right to work.
    • Confirm 5/10-year employment history; verify references; explain gaps.
    • Obtain criminal record checks (DBS) where lawful.
    • Conduct financial/credit checks where appropriate.
    • Retain records securely and for lawful periods.JURISDICTION
    •
    • Implement re-checks as required.
    • Use audit trails and reporting for compliance evidence.
Addendum: Cross‑Comparison Enhancements (Incorporated Terms)
This Addendum forms part of, and prevails over any conflicting wording in, the main Terms where expressly stated below. It captures additional protections and operational details identified via deep comparison with a reference SaaS licence.
A1. Seat Management & Additional Users
A1.1 User credentials are individual (not to be shared) and must remain within assigned permissions.
A1.2 The Customer may request additional Users/modules at any time; if approved, access will be enabled in line with the Company’s process and invoiced at prevailing rates.
A1.3 The Customer shall prevent unauthorised access/use and promptly notify the Company of any suspected compromise.
A2. Acceptable Use – Prohibited Content/Activity
A2.1 The Customer shall not access, store, distribute, or transmit material via the Services that is unlawful, defamatory, obscene, discriminatory, promotes violence or illegal activity, contains sexually explicit images, or introduces malware/viruses. The Company may suspend access for material breaches while investigating.
A3. Service Availability & Support
A3.1 24×7 Target availability, subject to planned or emergency maintenance. The Company will use commercially reasonable endeavours to minimise disruption and, where reasonably practicable, provide advance notice of emergency work.
A3.2 A telephone/online support channel is available during published Normal Business Hours at no additional charge. Any enhanced SLAs/service credits apply only if agreed in a separate SLA.
A4. Notices (Email Permitted)
A4.1 Formal notices may be served by hand, pre‑paid first‑class post/next‑day courier or by email to the notified legal‑notices address. Deemed receipt for email is 09:00 on the next Business Day after sending. Service of proceedings by email is excluded.
A5. Third‑Party Providers
A5.1 The Services may enable access to third‑party products/services. Any such engagement is solely between the Customer and the third party. The Company is not responsible for third‑party terms, performance, delivery, or content.
A6. Payment Clarifications
A6.1 Fees are payable in GBP, non‑cancellable and non‑refundable, unless expressly stated otherwise.
A6.2 Recurring fees may be amended at the start of each renewal Term; updated pricing will be communicated in advance and reflected in renewal documents.
A7. Data Protection Enhancements
A7.1 Breach Notification: The Company will notify the Customer of any Personal Data Breach within 48 hours of awareness and will provide updates as more information becomes available.
A7.2 Audit: The Company will maintain records sufficient to demonstrate compliance with processor obligations and will permit audits on reasonable notice and at reasonable times, subject to confidentiality and security requirements.
A7.3 Controller/Processor Role: Where the Company provides purely hosted functionality without accessing personal data, the Customer remains Controller and the Company acts only as solution provider/host. Where the Company processes Personal Data on behalf of the Customer for support or managed services, it acts as Processor strictly per the DPA and customer instructions.
A7.4 Anonymised Analytics (Opt‑In): If expressly authorised in writing, the Company may use anonymised/aggregated telemetry for service improvement, statistical analysis, or research. Such use will never identify individuals nor enable access to raw personal data beyond what the Customer explicitly authorises for support.
A8. Third‑Party Rights (Contracts (Rights of Third Parties) Act 1999)
A8.1 No person other than the parties (and permitted successors/assignees) has rights to enforce any term of this Agreement.
A9. Supplier Warranties – Services
A9.1 In addition to software warranty, the Company warrants that any Services (implementation, training, support) will be provided with reasonable skill and care. The Customer’s sole remedy for breach is re‑performance or, where re‑performance is not feasible, a proportionate refund for the affected Services.
A10. Customer Operational Duties (Security & Training)
A10.1 The Customer is responsible for: (i) maintaining compliant IT/network environments; (ii) deploying and updating anti‑virus/anti‑malware on connected devices; (iii) training Users and ensuring competence for their roles; and (iv) ensuring decisions made using outputs are reviewed by competent personnel and in accordance with HR policy and BS7858:2019.
A11. Survival & Priority
A11.1 This Addendum is incorporated into the Agreement. Where an express conflict exists between the Addendum and the main body, the Addendum prevails for the conflicting point only. All other terms remain unchanged.

`,
    };
  },
  created() {
    this.options.columns = [...this.options.columns, this.actionObj];
  },
  methods: {
    // small helper to safely escape text when building HTML
    escapeHtml(str) {
      if (!str) return "";
      return String(str)
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#39;");
    },
    /**
     * for open add edit modal
     */

    openAddEditModal() {
      this.isAddEditModalActive = true;
    },
    getCompanyCategories() {
      axiosGet(actions.CATEGORIES)
        .then((res) => {
          this.categories = res.data;
        })
        .catch((error) => {});
    },

    /**
     * for close add edit modal
     */
    closePaymentModal() {
      $("#payment-Modal").modal("hide");
      this.isPaymentModalActive = false;
    },

    /**
     * $emit Form datatable action
     */
    getListAction(rowData, actionObj, active) {
      this.rowData = rowData;

      if (actionObj.title == "Delete") {
        this.openDeleteModal();
      } else if (actionObj.title == this.$t("select")) {
        location.replace("/admin/stripePay/" + rowData.id);
      }
    },
    acceptTerms() {
      // commit the selection and proceed to payment
      this.inputs.category_name = this.pendingSelection.categoryObj;
      this.inputs.company_id = this.userCompany;
      this.inputs.package_id = this.pendingSelection.packageId;

      this.showTermsModal = false;
      this.isPaymentModalActive = true; // your existing payment modal
    },

    declineTerms() {
      // reset pending and close
      this.pendingSelection = { packageId: null, categoryObj: null };
      this.showTermsModal = false;
      this.agreedToTerms = false;
    },
    detail(id) {
      window.location = "/admin/package/detail/" + id;
    },

    /**
     * for open confirmation modal
     */
    openDeleteModal() {
      this.deleteConfirmationModalActive = true;
    },

    /**
     * confirmed $emit Form confirmation modal
     */
    confirmed() {
      let url = `${actions.PACKAGE_DISTROY}/${this.rowData.id}`;
      this.deleteLoader = true;
      this.axiosGet(url)
        .then((response) => {
          this.deleteLoader = false;
          $("#demo-delete").modal("hide");
          this.cancelled();
          this.$toastr.s(response.data.message);
          this.searchAndSelectFilterOptions();
        })
        .catch(({ error }) => {
          // Trigger after error
        })
        .finally(() => {
          this.$hub.$emit("reload-" + this.tableId);
        });
    },

    /**
     * cancelled $emit Form confirmation modal
     */
    cancelled() {
      this.deleteConfirmationModalActive = false;
      this.reSetData();
    },
    reSetData() {
      this.rowData = {};
      this.selectedUrl = "";
    },
    getPackages() {
      axiosGet(actions.PACKAGE_LISTING)
        .then((res) => {
          this.packages = res.data.data;
        })
        .catch((error) => {});
    },
    async btnSubmit(id) {
      if (this.inputs.category_id == null) {
        this.$toastr.e("Please Select Your Business Category");
        return;
      }

      try {
        const response = await axiosGet(actions.LAST_INVOICE);
        if (response.data.result === "paid") {
          this.$toastr.w(this.$t("package_already_exists"));
          return;
        }

        // capture selection but do NOT open payment yet
        const category =
          this.categories.find((e) => e.id === this.inputs.category_id) || null;

        this.pendingSelection.packageId = id;
        this.pendingSelection.categoryObj = category;

        // open Terms modal
        this.agreedToTerms = false;
        this.showTermsModal = true;
      } catch (e) {
        // optional: surface a friendly error
        this.$toastr.e(this.$t("something_went_wrong") || "Something went wrong.");
      }
    },
  },
  mounted() {
    this.getPackages();
    this.getCompanyCategories();
  },
  computed: {
    userCompany() {
      return this.$store.state.user.loggedInUser.company_id;
    },
    formattedTerms() {
      const raw = this.termsContent || "";
      const lines = raw.split(/\r?\n/);
      let html = "";
      let inList = false;
      lines.forEach((ln) => {
        const line = ln.replace(/\t/g, "    ");
        const trimmed = line.trim();

        if (!trimmed) {
          if (inList) {
            html += `</ul>`;
            inList = false;
          }
          return;
        }

        // Numbered headings like "1. Interpretation and Definitions"
        const numbered = trimmed.match(/^(\d+)\.\s*(.*)/);
        // Bullet markers (•, -, *) and sub-bullets (◦)
        const bullet =
          trimmed.match(/^[\u2022\-\*]\s*(.*)/) || trimmed.match(/^◦\s*(.*)/);

        if (numbered) {
          if (inList) {
            html += `</ul>`;
            inList = false;
          }
          html += `<h4 class="tc-heading">${this.escapeHtml(
            numbered[1] + ". " + numbered[2]
          )}</h4>`;
        } else if (bullet) {
          if (!inList) {
            html += `<ul class="tc-list">`;
            inList = true;
          }
          html += `<li>${this.escapeHtml(bullet[1])}</li>`;
        } else {
          if (inList) {
            html += `</ul>`;
            inList = false;
          }
          html += `<p>${this.escapeHtml(trimmed)}</p>`;
        }
      });
      if (inList) html += `</ul>`;
      return html;
    },
  },
};
</script>

<style scoped>
.terms-content {
  font-family: Arial, Helvetica, sans-serif;
  font-size: 14px;
  color: #333;
  line-height: 1.6;
  padding: 12px;
}
.terms-content .tc-heading {
  margin-top: 1rem;
  font-size: 1rem;
  color: #292f4c;
  font-weight: 600;
}
.terms-content p {
  margin: 0.5rem 0;
  text-align: justify;
}
.terms-content ul.tc-list {
  margin: 0.5rem 0 1rem 1.2rem;
  padding-left: 0.6rem;
}
.terms-content ul.tc-list li {
  margin: 0.25rem 0;
}
.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}
</style>
